export var ThemeOptions = /*#__PURE__*/ function(ThemeOptions) {
    ThemeOptions["DARK"] = "dark";
    ThemeOptions["LIGHT"] = "light";
    return ThemeOptions;
}({});
// The skins of a theme, format is {baseTheme}-{varientName}
export var ThemeSkin = /*#__PURE__*/ function(ThemeSkin) {
    ThemeSkin["NONE"] = "none";
    ThemeSkin["GREEN"] = "light-green";
    return ThemeSkin;
}({});
export var ThemeSurface = /*#__PURE__*/ function(ThemeSurface) {
    ThemeSurface["PRIMARY"] = "surface-primary";
    ThemeSurface["SECONDARY"] = "surface-secondary";
    ThemeSurface["TERTIARY"] = "surface-tertiary";
    return ThemeSurface;
}({});

//# sourceMappingURL=constants.js.map